import React from 'react';
import PropTypes from 'prop-types';

function CuiIndexBattery({ value }) {
  const percentage = Math.max(0, Math.min(value, 100));

  const getColor = (val) => {
    if (val <= 0) return '#000000';
    if (val <= 25) return '#BF182C';
    if (val <= 50) return '#EEC73C';
    if (val <= 75) return '#5FB83A';
    return '#0E803C';
  };

  const color = getColor(percentage);

  return (
    <svg width="32" height="16" viewBox="0 0 32 16">
      <rect
        x="1"
        y="2"
        width="26"
        height="12"
        rx="3"
        ry="3"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
      />

      <rect x="27" y="6" width="3" height="4" rx="1" fill={color} />

      {percentage > 0 && (
        <rect
          x="3"
          y="4"
          width={(percentage / 100) * 22}
          height="8"
          rx="2"
          fill={color}
        />
      )}
    </svg>
  );
}

CuiIndexBattery.propTypes = {
  value: PropTypes.number,
};

CuiIndexBattery.defaultProps = {
  value: 0,
};

export default CuiIndexBattery;
